(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const configNode = document.querySelector('[data-cart-config]');
  if (!drawer || !configNode || !window.fetch || !drawer.showModal) return;
  const config = JSON.parse(configNode.textContent);
  const unique = new Set(config.uniqueIds.map(String));
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let lastCart = null;
  let previousFocus = null;
  let allowCheckout = false;
  const page = document.querySelector('.b-cart-page');
  const message = (text, error = false) => {
    document.querySelectorAll('[data-cart-message], [data-cart-page-message]').forEach(node => {
      node.textContent = text;
      node.classList.toggle('b-cart-error', error);
    });
  };
  const request = async (path, data) => {
    const response = await fetch(root + path, {
      credentials: 'same-origin',
      cache: 'no-store',
      ...(data ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) } : {})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : config.error);
    return result;
  };
  const open = () => {
    if (!drawer.open) {
      previousFocus = document.activeElement;
      drawer.showModal();
    }
  };
  const close = () => drawer.close();
  const syncProduct = () => {
    document.querySelectorAll('[data-cart-product-form]').forEach(wrapper => {
      const button = wrapper.querySelector('button[name=add]');
      if (!button || !lastCart) return;
      if (!button.dataset.originalLabel) button.dataset.originalLabel = button.textContent;
      const productId = wrapper.dataset.productId;
      const exists = unique.has(productId) && lastCart.items.some(item => String(item.product_id) === productId);
      button.textContent = exists ? config.view : button.dataset.originalLabel;
    });
  };
  const render = async cart => {
    const url = new URL(root, location.origin);
    url.searchParams.set('section_id', 'brusion-cart-drawer');
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(config.error);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const panel = html.querySelector('[data-cart-panel]');
    if (!panel) throw new Error(config.error);
    document.querySelectorAll('[data-cart-panel]').forEach(current => current.replaceWith(panel.cloneNode(true)));
    document.querySelectorAll('[data-cart-unique]').forEach(item => unique.add(item.dataset.cartProduct));
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
    document.querySelectorAll('[data-cart-open].b-bag').forEach(node => node.setAttribute('aria-label', config.bag + ' (' + cart.item_count + ')'));
    lastCart = cart;
    syncProduct();
  };
  const normalize = async cart => {
    const seen = new Set();
    const changes = [];
    cart.items.forEach((item, index) => {
      if (!unique.has(String(item.product_id))) return;
      const quantity = seen.has(String(item.product_id)) ? 0 : 1;
      seen.add(String(item.product_id));
      if (item.quantity !== quantity) changes.push({ line: index + 1, quantity });
    });
    for (const change of changes.reverse()) cart = await request('cart/change.js', change);
    if (changes.length) message(config.corrected);
    return cart;
  };
  const refresh = async () => {
    const cart = await normalize(await request('cart.js'));
    await render(cart);
    return cart;
  };
  const operation = async (action, announce = true) => {
    if (busy) return;
    busy = true;
    drawer.setAttribute('aria-busy', 'true');
    page?.setAttribute('aria-busy', 'true');
    document.querySelectorAll('[data-cart-product-form] button[name=add]').forEach(node => node.setAttribute('aria-busy', 'true'));
    try { await action(); }
    catch (error) { message(error.message || config.error, true); if (announce && !page) open(); }
    finally {
      busy = false;
      drawer.removeAttribute('aria-busy');
      page?.removeAttribute('aria-busy');
      document.querySelectorAll('[data-cart-product-form] button[name=add]').forEach(node => node.removeAttribute('aria-busy'));
    }
  };
  document.addEventListener('submit', event => {
    const product = event.target.closest('[data-cart-product-form]');
    if (product && event.target.matches('form')) {
      event.preventDefault();
      operation(async () => {
        message('');
        const data = new FormData(event.target);
        const id = String(data.get('id'));
        let cart = await normalize(await request('cart.js'));
        const exists = unique.has(product.dataset.productId) && cart.items.some(item => String(item.product_id) === product.dataset.productId);
        if (!exists) {
          const properties = {};
          for (const [key, value] of data) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match) properties[match[1]] = value;
          }
          try { await request('cart/add.js', { items: [{ id, quantity: 1, properties }] }); }
          catch (error) {
            await refresh();
            open();
            throw error;
          }
          cart = await normalize(await request('cart.js'));
        }
        await render(cart);
        open();
        message(exists ? config.already : config.added);
      });
      return;
    }
    if (event.target.matches('[data-cart-review]') && event.submitter?.name === 'checkout' && !allowCheckout) {
      event.preventDefault();
      operation(async () => {
        message('');
        const cart = await refresh();
        if (!cart.item_count) return;
        const form = drawer.open ? drawer.querySelector('[data-cart-review]') : page?.querySelector('[data-cart-review]');
        if (!form) throw new Error(config.error);
        allowCheckout = true;
        try { form.requestSubmit(form.querySelector('[data-cart-checkout]')); }
        finally { allowCheckout = false; }
      });
    }
  });
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-cart-open]');
    if (opener && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      event.preventDefault();
      open();
      operation(async () => { message(''); await refresh(); });
    }
    if (event.target.closest('[data-cart-close]')) close();
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      operation(async () => {
        message('');
        await request('cart/change.js', { id: remove.dataset.cartRemove, quantity: 0 });
        await refresh();
        (drawer.open ? drawer : page)?.querySelector('[data-cart-remove], [data-cart-checkout], a')?.focus();
      });
    }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-cart-quantity]')) return;
    const input = event.target;
    operation(async () => {
      const value = Number(input.value);
      if (!Number.isInteger(value) || value < 0) throw new Error(config.error);
      await request('cart/change.js', { id: input.dataset.key, quantity: value });
      await refresh();
    });
  });
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const rect = drawer.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  drawer.addEventListener('close', () => previousFocus?.focus());
  document.addEventListener('brusion:variant-changed', syncProduct);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) operation(refresh); });
  window.addEventListener('pageshow', event => { if (event.persisted) operation(refresh); });
  document.querySelectorAll('[data-cart-unique]').forEach(item => unique.add(item.dataset.cartProduct));
  operation(refresh, false);
})();
